import styled from 'styled-components';

export const LogoContainer = styled.div`
  position: relative;
  z-index: 3;
  width: 140px;
  height: 32px;
  
  svg {
    fill: ${({ theme }) => theme.white}
  }
`;
